<template>
	<v-card class="elevation-0 events-page page">
		<PageBlocked v-if="isBlocked" :blockRole="blockRole" />
		<div v-else-if="isBlocked !== null">
      <div class="date-wrapper">
        <FilterChipButton
            :isButtonActive="isButtonActive"
            :chipsList="chipsList"
            :clearFilter="clearFilter"
            @handleChipClick="handleChipClick"
        />
        <div v-if="filterModalIsVisible">
          <FilterModal
              :filterModalIsVisible="filterModalIsVisible"
              :currentModalFilter="currentModalFilter"
              :currentModalLabel="currentModalLabel"
              :selectedChips="selectedChips"
              :filters="filters"
              :dateError="date.error"
              :dateOption="date.option"
              :dateRange="date.selectedRange"
              @closeModal="closeModal"
              @applySelection="applySelection"
              @setItem="setItem"
          />
        </div>
      </div>

			<div class="d-flex">
				<v-skeleton-loader
					v-if="isLoading"
					v-bind="attrs"
					max-width="555"
					width="100%"
					type="list-item, list-item-three-line, card-heading"
				></v-skeleton-loader>

				<div class="user_preview" v-else style="width: 100%">
					<div v-for="(user, index) in users" :key="index">
						<router-link
							:to="{
								name: isCurrentUser(user.user_id) ? 'profile' : 'user-by-id',
								params: isCurrentUser(user.user_id) ? [] : { id: user.user_id },
							}"
							class="text-decoration-none"
							@click.native="handleUserClick(user)"
						>
							<UserPreview :user="user" />
						</router-link>
					</div>
				</div>
			</div>

			<div
				class="d-flex my-9 justify-center home-page__pagination"
				v-if="!isLoading && users.length > 0"
			>
				<Pagination
					:page="filters.page"
					:pageCount="+this.pageCountAttendees"
					v-on:pageChange="onPageChange"
				/>
			</div>

			<div
				class="d-flex my-9 justify-center home-page__pagination"
				v-if="!isLoading && users.length <= 0"
			>
				<NewsFeedEmpty
					title="Users not found at this moment."
					description="Check back later."
					centering="center"
				/>
			</div>

			<v-btn v-show="isVisible" @click="scrollToTop" bottom right fixed fab>
				<v-icon>mdi-chevron-up</v-icon>
			</v-btn>
		</div>
	</v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import UserPreview from '@/components/User/UserPreview'
import NewsFeedEmpty from '@/components/Post/NewsFeedEmpty'
import Block from '@/mixins/Block.js'
import Dwh from '@/mixins/Dwh'
import PageBlocked from '@/components/PageBlocked'
import Pagination from '@/components/Pagination.vue'
import _ from 'lodash'
import FilterChipButton from '@/components/FilterChipButtons.vue'
import FilterModal from '@/components/Modals/FilterModal'
import Filter from '@/mixins/Filter'

export default {
	name: 'UsersPage',
	mixins: [Block, Dwh, Filter],
	components: {
		FilterChipButton,
		NewsFeedEmpty,
		UserPreview,
		PageBlocked,
		Pagination,
		FilterModal,
	},
	methods: {
		...mapActions('event', ['getAttendeesEvent', 'clearAttendeesEvent']),
		...mapActions('list', ['getListsMeta', 'getList', 'clearLists']),
		...mapActions('settings', ['getUserSettings']),
		...mapActions('app', ['setPageTitle']),

		isCurrentUser(userId) {
			if (!this.profile) {
				return false
			}

			const { user_id: currentUserId } = this.profile
			return userId === currentUserId
		},
		toggleVisibility() {
			this.isVisible = window.scrollY > 1000
		},
		scrollToTop() {
			window.scrollTo({
				top: 0,
				behavior: 'smooth',
			})
		},
		handleUserClick(user) {
			this.sendTrigger({
				category: 'User',
				action: 'click_user_app_users',
				module: 'App Users',
				data: user,
			})
		},
	},

	created() {
		if (!this.isBlocked || this.isBlocked === null) {
			if (!this.user) {
				this.getUserSettings()
			}
			this.getAttendeesEvent(this.requestQuery)
		}
	},

	computed: {
		...mapGetters('auth', ['profile']),
		...mapGetters('event', ['isLoading', 'pageCountAttendees', 'attendees']),
		...mapGetters('tag', ['tags']),
		...mapGetters('settings', ['user']),

		users() {
			return this.attendees || []
		},
	},
	mounted() {
		window.addEventListener('scroll', this.toggleVisibility)
		this.setPageTitle('App Users')
	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.toggleVisibility)
		this.clearAttendeesEvent()
		this.setPageTitle('')
		// this.clearLists()
	},

	data() {
		return {
			attrs: {
				class: 'mb-6 mt-6',
				elevation: 0,
			},
			isVisible: false,
			timer: 0,
			showError: false,
			error: '',
			pageBlockedName: 'users',
		}
	},
}
</script>

<style lang="scss">
.users-page {
	background: #f1f1f1 !important;

	&__divider {
		border-color: #000 !important;
		mix-blend-mode: normal;
		opacity: 0.1;
	}

	&__time {
		color: rgb(74, 74, 74);
		font-size: 24px;
		font-family: Montserrat, sans-serif;
		font-weight: bold;
	}

	.post {
		&__search {
			background: white;
			height: 54px;
			border-radius: 10px;
			border: 1px solid rgb(230, 230, 230);
			max-width: 600px;
		}

		@media screen and (max-width: 1264px) {
			&__search {
				max-width: none;
				width: 100%;
			}
		}
	}
}
</style>
